import i18n from '@/lang'

/*
 * 对象重置
 * @param object object  要重置的对象
 * @param object defaultValues 默认值对象
 * @return void
 */
export function resetObject ( object, defaultValues ) {
  for(let index in object) {
    if(typeof object[index] === 'object') { 
      resetObject( object[index] )
    }
    else {
      //如果有传默认值，默认值中存在该属性，并且该属性值非对象
      if(typeof defaultValues !== 'undefined' && typeof defaultValues[index] !== 'undefined' && typeof defaultValues[index] !== 'object') {
        object[index] = defaultValues[index]
      }
      else {
        object[index] = ''
      }
    }
  }
}

/*
 * 可以保留两位小数的字段校验是否为0，为0时，给出错误提示。作为async validator的校验规则rules
 * @param string fieldName 字段名称
 * @return function
 */
export function validatorZero(fieldName) {
  fieldName = fieldName || ''
  return function validator(rule, value, callback, source, option) {
      var errors = []
      if(parseInt(value*100) === 0) {
        errors.push( new Error( i18n.t('error.cannotBeZero', {field: fieldName}) ) )
      }
      return errors
    }
}

/*
 * 乘法函数，用来得到精确的乘法结果
 * 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
 * @param number arg1 
 * @param number arg2
 * @return number
 */
export function accMul(arg1, arg2) {
  let m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString(),
      num1, num2
  try {
    if(!/e/.test(s1)) {
      m += s1.split(".")[1].length
    }
  }
  catch(e) {
  }
  try {
    if(!/e/.test(s2)) {
      m += s2.split(".")[1].length
    }
  }
  catch(e) {
  }

  num1 = /e/.test(s1) ? Number(s1) : Number(s1.replace('.', ''))
  num2 = /e/.test(s2) ? Number(s2) : Number(s2.replace('.', ''))
  return num1 * num2 / Math.pow(10, m)
}

/* 
 * 除法函数，用来得到精确的除法结果
 * 说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
 * @param number arg1 
 * @param number arg2
 * @return number
 */
export function accDiv(arg1, arg2) {
  let t1 = 0, t2 = 0, 
      s1 = arg1.toString(),
      s2 = arg2.toString(),
      num1, num2
  try {
    if(!/e/.test(s1)) {
      t1 = s1.split(".")[1].length //获取小数位数
    }
  }
  catch (e) {
  }
  try {
    if(!/e/.test(s2)) {
      t2 = s2.split(".")[1].length
    }
  }
  catch (e) {
  }

  num1 = /e/.test(s1) ? Number(s1) : Number(s1.replace(".", "")) //转换成整数
  num2 = /e/.test(s2) ? Number(s2) : Number(s2.replace(".", ""))
  return (num1 / num2) * Math.pow(10, t2 - t1)
}


// WEBPACK FOOTER //
// ./src/utils/index.js